{
  "settings": "Indstillinger",
  "yourDigitalAssistant": "Din digitale assistent",
  "getStarted": "Kom i gang",
  "login": "Login",
  "loggingIn": "Log ind ...",
  "darkMode": "Mørk tilstand",
  "clearHistory": "Ryd historie",
  "historyCleared": "Historien ryddet",
  "ChangeLanguage": "Sprog",
  "termsAndConditions": "Vilkår og betingelser",
  "messagePlaceholder": "Skriv din besked her ...",
  "messagePlaceholderDisabled": "Indtastning deaktiveret ...",
  "feedbackTitle": "Bedøm din oplevelse",
  "feedbackPlaceholder": "Fortæl os om det (valgfrit)",
  "feedbackSend": "Sende",
  "feedbackClose": "Luk",
  "sessionExpired": "Din session er udløbet på grund af inaktivitet.",
  "startNewSession": "Start en ny session",
  "apiError": "Ups! Der gik noget galt. Vi arbejder på at få løst dette så snart vi kan.",
  "apiErrorOffline": "Du er ikke tilsluttet internettet.",
  "tryAgain": "Prøv igen",
  "startOver": "Start igen",
  "chatEnded": "Chat er afsluttet.",
  "chatEndedThankYou": "Tak fordi du chatter med os!",
  "closeChat": "Tæt",
  "startNewChat": "Chat igen",
  "humanTakeoverStarted": "Du overføres nu til kundeservice ...",
  "humanTakeoverQueued": "Venter på at få forbindelse til en agent",
  "humanTakeoverAnAgent": "En agent",
  "humanTakeoverAgentEntered": "gik ind i samtalen",
  "humanTakeoverAgentLogout": "forlod samtalen",
  "humanTakeoverTransfer": "Du overføres til en ny agent",
  "humanTakeoverEnded": "Du chatter nu med din digitale assistent",
  "version": "Version",
  "formIntroText": "Udfyld venligst følgende formular for at begynde at chatte med os.",
  "formFirstName": "Fornavn",
  "formLastName": "Efternavn",
  "formName": "Navn",
  "formEmail": "E-mail",
  "formWrongEmail": "Angiv en gyldig e-mail-adresse.",
  "formPhone": "Telefon",
  "formShipmentId": "Forsendelses-ID",
  "formQuestion": "Dit spørgsmål",
  "formAccountNumber": "Kontonummer (for erhvervskunder)",
  "formAddress": "Adresse",
  "formPostcode": "postnummer",
  "formCity": "By",
  "formCountry": "Land",
  "formSubmitButton": "Start chat",
  "formEmptyFieldError": "Ikke tilladt at være tom.",
  "formPhoneNumberValidationError": "Ikke et gyldigt telefonnummer.",
  "formInputIsBiggerThan50": "Skal være højst 50 tegn.",
  "formInputIsBiggerThan100": "Skal højst være 100 tegn.",
  "formInputIsBiggerThan2000": "Skal højst være 2000 tegn.",
  "widgetEventOnline": "DA-meddelelse: Brugeren er tilbage online.",
  "widgetEventHidden": "DA-meddelelse: Widget er skjult.",
  "widgetEventVisible": "DA-meddelelse: Widget er synlig.",
  "widgetEventVisibleMinimized": "DA-meddelelse: Widget er synlig, men minimeret.",
  "widgetEventMinimized": "DA-meddelelse: Widget er minimeret.",
  "widgetEventMaximized": "DA-meddelelse: Widget er maksimeret.",
  "widgetEventSessionExpired": "DA-meddelelse: Widget-session er udløbet.",
  "widgetEventHangupHuman": "DA -meddelelse: Bruger afslutter Human overtagelsessession.",
  "widgetEventUserTyping": "DA-meddelelse: Bruger skriver.",
  "fileTooLarge": "Du forsøger at vedhæfte for store filer.",
  "tooManyDiles": "Du forsøger at vedhæfte for mange filer.",
  "fileInvalidType": "Du forsøger at vedhæfte ugyldige filtyper.",
  "attachmentsDropHere": "Slip her for at uploade eller",
  "attachmentsBrowse": "Gennemse filer",
  "attachmentsExtenstionQuantity": "pdf eller billeder (op til 10 filer)",
  "attachmentsSize": "op til 30 MB",
  "attachmentsFailedUploading": "Upload mislykkedes",
  "attachmentsUploading": "Uploader ...",
  "minimizeExpandText": "Live chat med os nu!",
  "popupWidgetNotificationMessage": "Du har modtaget en ny besked!",
  "tabWidgetNotificationMessage": "Ny besked!",
  "datepickerSendButton": "Sende"
}
